import { useState } from 'react'

export const useRosterMode = () => {
  const [currentMode, setCurrentMode] = useState('default')
  const [selectedBookedEvent, setSelectedBookedEvent] = useState(null)
  const [showBookedEventDialog, setShowBookedEventDialog] = useState(false)
  const [showReschedulePopup, setShowReschedulePopup] = useState(false)
  const [timeToRescheduleTo, setTimeToRescheduleTo] = useState(null)

  const switchToReassignMode = () => {
    setCurrentMode('reassign')
    setShowBookedEventDialog(false)
  }

  const resetToDefaultMode = () => {
    setCurrentMode('default')
    if (selectedBookedEvent) {
      setShowBookedEventDialog(true)
    }
  }

  const openBookedEventDialog = (eventInfo) => {
    setSelectedBookedEvent(eventInfo)
    setShowBookedEventDialog(true)
  }

  const closeBookedEventDialog = () => {
    setShowBookedEventDialog(false)
    setSelectedBookedEvent(null)
  }

  const openReschedulePopup = (time) => {
    setTimeToRescheduleTo(time)
    setShowReschedulePopup(true)
  }

  const closeReschedulePopup = () => {
    setShowReschedulePopup(false)
  }

  return {
    currentMode,
    selectedBookedEvent,
    showBookedEventDialog,
    showReschedulePopup,
    timeToRescheduleTo,
    switchToReassignMode,
    resetToDefaultMode,
    openBookedEventDialog,
    closeBookedEventDialog,
    openReschedulePopup,
    closeReschedulePopup,
    setSelectedBookedEvent,
  }
} 